export default __webpack_public_path__ + "static/media/couple.71498702.png";